<template>
  <Modal @cancel="closeModal" cClass="mw222" iClass="typo-icon-14" :mClass="bodyClassModal">
    <template #header>
      <p class="typo-heading20 typo-medium text-light-high" :class="{ 'text-danger': type == 'delete' }">{{ titleModal }}</p>
    </template>
    <template #default>
      <!-- Body Delete -->
      <template v-if="type == 'delete'">
        <div class="form-group">
          <p class="typo-paragraph14 typo-regular-150 text-light-low mb-1" v-html="$t('generals.confirm.delete', { name: item.name })"></p>
          <label class="mb-1 typo-paragraph14 typo-regular-150 text-light-low" v-html="$t('generals.confirm.typeConfirm')"></label>
          <input placeholder="Type here" ref="inputTitle" v-focus class="input-field input-field-block" type="text" @keyup.enter="doSubmit" v-model="retypeDelete" />
          <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
        </div>
      </template>

      <!-- Body settings -->
      <template v-if="type == 'settings'">
        <div class="form-group mb-2">
          <label class="mb-2 typo-button14 typo-medium text-light-high">{{ $t("analytic.ab.testDuration") }}</label>
          <div class="row mb-2">
            <div class="col-6">
              <GpNumber v-model="duration" :min="1" />
            </div>
          </div>
          <Noti
            v-if="type == 'settings'"
            class="mb-2"
            type="infor"
            :htmlDesc="$t('analytic.ab.weRecommend')"
          />
        </div>

        <template v-if="shopInfo && shopInfo.gaLoggedIn">
          <div class="form-group mt-4">
            <label class="mb-2 typo-button14 typo-medium text-light-high d-flex">
              <span>{{ $t("analytic.ab.webAnalyticAccount") }}</span>
              <a class="ml-auto rl cursor-pointer" @click.stop="goToNewSetting">{{ $tc("generals.setting", 2 ) }}</a>
            </label>
            <div class="bg-light2 p-2 d-flex align-items-center btn-block">
              <template v-if="selectedAccount">
                <svg class="mr-2" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M31.983 16.2993C31.983 14.9883 31.8741 14.0316 31.6385 13.0395H16.3186V18.9568H25.3111C25.1298 20.4273 24.1508 22.6419 21.9751 24.13L21.9446 24.3281L26.7885 27.9951L27.1241 28.0278C30.2062 25.2462 31.983 21.1537 31.983 16.2993" fill="#4285F4"/>
                  <path d="M16.3188 31.8902C20.7243 31.8902 24.4228 30.4728 27.1243 28.0279L21.9753 24.1301C20.5974 25.0691 18.7481 25.7246 16.3188 25.7246C12.0039 25.7246 8.34162 22.9432 7.03613 19.0986L6.84477 19.1145L1.80806 22.9236L1.74219 23.1026C4.4254 28.3113 9.93695 31.8902 16.3188 31.8902Z" fill="#34A853"/>
                  <path d="M7.03611 19.0986C6.69164 18.1065 6.49229 17.0434 6.49229 15.945C6.49229 14.8465 6.69164 13.7836 7.01799 12.7915L7.00886 12.5802L1.90901 8.70987L1.74215 8.78743C0.636269 10.9489 0.00170898 13.3761 0.00170898 15.945C0.00170898 18.514 0.636269 20.9411 1.74215 23.1025L7.03611 19.0986" fill="#FBBC05"/>
                  <path d="M16.3188 6.1654C19.3828 6.1654 21.4496 7.45872 22.6281 8.53951L27.2331 4.14574C24.4049 1.57682 20.7244 3.05176e-05 16.3188 3.05176e-05C9.93699 3.05176e-05 4.42542 3.57878 1.74219 8.78745L7.01803 12.7915C8.34165 8.94696 12.0039 6.1654 16.3188 6.1654" fill="#EB4335"/>
                </svg>
                <div class="d-flex flex-column justify-content-center">
                  <h6 class="typo-paragraph14 typo-regular text-light-high mb-half">{{ $t("accountSettings.google.account")}}</h6>
                  <p class="typo-paragraph12 typo-regular text-light-low">{{ selectedAccount.name }}</p>
                </div>
              </template>
              <template v-else>
                <div class="circle mr-2">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.9099 18.0892L9.65492 10.8334H5.83325V9.16674H7.98825L6.32159 7.50007H5.83325C4.45254 7.50007 3.33325 8.61936 3.33325 10.0001C3.33325 11.3808 4.45254 12.5001 5.83325 12.5001H8.33325V14.1667H5.83325C3.73455 14.1685 1.96212 12.609 1.69663 10.5272C1.43113 8.44532 2.75545 6.49095 4.78742 5.9659L1.90992 3.08924L3.08909 1.9109L18.0891 16.9109L16.9108 18.0884L16.9099 18.0892ZM16.7799 13.2442L15.5899 12.0551C16.4886 11.4324 16.8785 10.298 16.5524 9.25443C16.2263 8.21086 15.2599 7.50024 14.1666 7.50007H11.6666V5.8334H14.1666C15.9333 5.83362 17.5077 6.94794 18.0954 8.61399C18.6831 10.28 18.1563 12.1356 16.7808 13.2442H16.7799Z" fill="#F44336"/>
                  </svg>
                </div>

                <div class="d-flex flex-column justify-content-center">
                  <h6 class="typo-paragraph14 typo-regular text-light-high mb-half">{{ $t("analytic.ab.noAccount")}}</h6>
                </div>
              </template>
            </div>
            
          </div>
        </template>
        <template v-else>
          <div class="warning-no-tracking d-flex p-2">
            <div class="img d-flex align-items-start">
              <i class="icon icon-lock typo-icon-20 typo-bold"></i>
            </div>
            <div class="ml-2 content d-flex align-items-center flex-column">
              <p class="typo-paragraph14 typo-medium mb-1" v-html="$t('analytic.ab.warnLogin')"></p>
              <p class="typo-paragraph14 typo-medium" v-html="$t('analytic.ab.pleaseSeeArticle')"></p>
            </div>
          </div>
        </template>
        <div class="form-group">
          <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
        </div>
      </template>

      <!-- Body Rename -->
      <template v-if="type == 'rename'">
        <div class="col-12 p-0">
          <div class="form-group">
            <label class="label typo-button14 typo-medium text-light-high">{{ $t("analytic.ab.campTitle") }}</label>
            <input ref="inputTitle" v-focus class="input-field input-field-block" type="text" @keyup.enter="doSubmit" v-model="campaignName" />
            <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
          </div>
        </div>
      </template>
    </template>
    <template #footer>
      <div class="btn-group flex-row-reverse row">
        <!-- Footer -->
        <template v-if="['rename', 'settings'].includes(type)">
          <div class="col-5 pl-1">
            <!-- <button class="btn btn-default btn-block btn-primary" @click="doSubmit"></button> -->
            <ProcessButton class="btn-default btn-block" :disabled="formNotFilled" :status.sync="btnStatus" @click="doSubmit">
              <template #loading>{{ $t("generals.loading") }}...</template>
              <template #success>{{ $t("generals.success") }}</template>
              <template #error>{{ $t("generals.error") }}</template>
              <template #default>{{ textSubmitButton }}</template>
            </ProcessButton>
          </div>
          <div class="col-5 pr-0">
            <button class="btn btn-default btn-block btn-secondary2" @click="closeModal">{{ $t("generals.cancel") }}</button>
          </div>
        </template>

        <template v-if="type == 'delete'">
          <div class="col-5 pl-1">
            <!-- <button class="btn btn-default btn-block btn-danger" @click="doSubmit">{{ textSubmitButton }}</button> -->
            <ProcessButton class="btn-default btn-block" default="btn-danger" success="btn-danger" loading="btn-danger" :status.sync="btnStatus" @click="doSubmit">
              <template #loading>{{ $t("generals.loading") }}...</template>
              <template #success>{{ $t("generals.success") }}</template>
              <template #error>{{ $t("generals.error") }}</template>
              <template #default>{{ textSubmitButton }}</template>
            </ProcessButton>
          </div>
          <div class="col-5 pr-0">
            <button class="btn btn-default btn-block btn-outline-danger" @click="closeModal">{{ $t("generals.cancel") }}</button>
          </div>
        </template>
      </div>
    </template>
  </Modal>
</template>

<script>
import GpNumber from "@/core/shared/GpForms/components/GpNumber.vue";
import { mapActions, mapState } from "vuex";
import { actions } from "@/store/analytic/types";
import processButton from "@/mixins/processButton.js";
import errorHandle from "@/mixins/errorHandle.js";
import Noti from "@/core/shared/base/Notification"

export default {
  name: "SettingModal",
  components: {
    Noti,
    GpNumber
  },
  mixins: [processButton(), errorHandle()],
  props: {
    item: Object,
    type: {
      type: String,
      default: "settings"
    }
  },
  data: () => ({
    campaignName: "",
    duration: 7,
    retypeDelete: "",
    alertText: "",
    loading: {
      account: false,
      property: false,
      track: false
    },

    accountID: "",
  }),
  computed: {
    bodyClassModal() {
      if (this.type == "duplicateTo") {
        return "p-4 pt-3 pb-0";
      }
      return "p-4 pt-3";
    },
    titleModal() {
      switch (this.type) {
        case "delete":
          return this.$t("generals.delete");
        case "settings":
          return this.$t("analytic.ab.settings");
        case "rename":
          return this.$t("generals.rename");
      }
      return "";
    },
    textSubmitButton() {
      switch (this.type) {
        case "delete":
          return this.$t("generals.delete");
        case "rename":
          return this.$t("generals.apply");
        case "settings":
          return this.$t("generals.save");
      }
      return "";
    },
    ...mapState("analytic", {
      accounts: state => state.accounts
    }),
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    }),
    selectedAccount() {
      if (!this.accounts || !this.accounts.fetched) {
        return undefined;
      }
      return this.accounts.list.find(x => x.id == this.accountID);
    },
    formNotFilled() {
      if (this.type != "settings") {
        return false;
      }
      return false;
    }
  },
  created() {
    this.setOldData();

    // Only load ga data when logged in
    if (this.shopInfo?.gaLoggedIn == true) {
      // load account dropdown values
      this.loadAccounts();
    }
  },
  methods: {
    ...mapActions("analytic", {
      removeCampaign: actions.DELETE_CAMPAIGN_ANALYTIC,
      updateCampaign: actions.UPDATE_CAMPAIGN_ANALYTIC,
      fetchAccounts: actions.FETCH_ACCOUNTS_ANALYTIC,
    }),
    setOldData() {
      this.campaignName = this.item.name;
      this.duration = this.item.duration;

      this.accountID = this.shopInfo?.accountInfo?.webAnalyticsTools?.ga?.gaAccountId || "";
    },
    doSubmit() {
      switch (this.type) {
        case "delete":
          this.deleteCampaign();
          break;
        case "rename":
          this.renameCampaign();
          break;
        case "settings":
          this.settingCampaign();
          break;
      }
      return "";
    },
    deleteCampaign() {
      let deleteTextConfirm = "confirm";
      if (this.$i18n.locale == "fr") {
        deleteTextConfirm = "confirmer";
      }
      if (this.retypeDelete.trim() != deleteTextConfirm) {
        this.alertText = this.$t("generals.confirm.retypeIncorrect");
        return;
      }
      // this.gSnackbarCommit({
      //   message: this.$t("status.processing"),
      //   type: "loading"
      // });
      this.activeLoading();
      let textSuccess = this.$t("status.success");
      this.removeCampaign({ id: this.item.id })
        .then(() => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          this.activeSuccess();
          this.$emit("delete", this.item);
          this.closeModal();
          this.retypeDelete = "";
        })
        .catch(err => {
          const errText = this.getErrorMessage(err);
          this.alertText = errText;
          this.gSnackbarCommit({
            message: errText,
            type: "error"
          });
          this.activeError();
        })
        .finally(() => {
          setTimeout(() => {
            this.resetStatus();
          }, 1000);
        });
    },
    renameCampaign() {
      this.alertText = "";
      let name = this.campaignName.trim();
      if (!name || !name.length) {
        this.alertText = this.$t("analytic.ab.titleNotEmpty");
        return;
      }
      // this.gSnackbarCommit({
      //   message: this.$t("status.processing"),
      //   type: "loading"
      // });
      this.activeLoading();
      let textSuccess = this.$t("status.success");
      this.updateCampaign({ id: this.item.id, data: { name: this.campaignName } })
        .then(() => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          this.activeSuccess();
          this.$emit("rename", name);
          this.closeModal();
        })
        .catch(err => {
          const errText = this.getErrorMessage(err);
          this.alertText = errText;
          this.gSnackbarCommit({
            message: errText,
            type: "error"
          });
          this.activeError();
        })
        .finally(() => {
          setTimeout(() => {
            this.resetStatus();
          }, 1000);
        });
    },
    settingCampaign() {
      this.alertText = "";
      this.activeLoading();
      let textSuccess = this.$t("status.success");
      const data = {
        duration: this.duration
      };

      this.updateCampaign({ id: this.item.id, data })
        .then(() => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          this.$emit("setting", data);
          this.activeSuccess();
          this.closeModal();
        })
        .catch(err => {
          const errText = this.getErrorMessage(err);
          this.alertText = errText;
          this.gSnackbarCommit({
            message: errText,
            type: "error"
          });
          this.activeError();
        })
        .finally(() => {
          setTimeout(() => {
            this.resetStatus();
          }, 1000);
        });
    },
    closeModal() {
      this.$emit("close");
    },
    loadAccounts() {
      this.loading.account = true;
      this.fetchAccounts().finally(() => {
        this.loading.account = false;
      });
    },
    goToNewSetting() {
      const domain = this.shopInfo.shopifyDomain.replace('.myshopify.com', '')
      const appId = process.env.VUE_APP_GEMPAGES_APP_ID
      window.top.location.href = `https://admin.shopify.com/store/${domain}/apps/${appId}/app/preferences`
    }
  }
};
</script>

<style lang="scss" scoped>
.break-word {
  word-break: break-word;
}

.warn-info {
  background: rgba($mono1, 0.1);
}

::v-deep {
  .gp_base-select {
    &_display {
      background: $light1;
      border: 1px solid $light1 !important;
      &.active {
        border-color: $textLightModeHigh !important;
      }
    }

    &_dropdown {
      // max-height: 120px;
    }
  }
}

.opac60 {
  opacity: 0.6;
}

.warning-no-tracking {
  padding: 18px 16px;
  border-radius: $radius;
  background: rgba($accent-yellow, 0.5);
  position: relative;
}

.circle {
  border-radius: 50%;
  padding: 6px;
  width: 32px;
  height: 32px;
  background: #FAEDEC;
}
</style>
